<style>
  .purple_border {
    box-shadow: 4px 4px 1px rgb(126, 34, 206);
  }

  .black_border {
    box-shadow: 4px 4px 1px rgb(0, 0, 0);
  }
</style>

<div>
  <h2
    class="lg:mt-10 xs:mt-1 py-4 text-center text-3xl leading-9 font-extrabold text-[#7B68EE]"
  >
    All Notification
  </h2>

  <div class="relative m-10">
    <button
      class="absolute py-1 px-3 -left-8 -top-2 -rotate-[10deg] border border-black black_border bg-[#C963F8] text-white font-bold"
    >
      Limited-Time Offer!!
    </button>

    <div class="purple_border p-8 border border-black text-center rounded-xl">
      <!-- <span class="font-mono text-purple-700 font-bold">Vinmarts</span> -->
      Get ₹40 OFF on every product when you pay online! 💳✨ Shop now and save
      more! 🛍️
      <span class="text-blue-700 cursor-pointer font-extrabold" routerLink="/"
        >Shop Now
      </span>
    </div>
  </div>

  <!-- <div class="relative m-10">
    <span
      class="absolute -z-10 w-full h-full inset-1 bg-[#C963F8] rounded-xl"
    ></span>
    <button
      class="absolute py-1 z-10 px-3 -left-8 -top-2 -rotate-[10deg] black_border bg-[#C963F8] text-white font-bold"
    >
      NOTE!
    </button>

    <div class="p-8 border border-black purple_border bg-white rounded-xl z-20">
      The
      <span class="font-mono text-purple-700 font-bold">message</span>
      variable is a Laravel reserved word within this email context, so you
      should avoid using that as a field handle if you intend on using the email
      feature.
    </div>
  </div> -->
</div>
